import Typography, { ETypo, ETypoColor } from "@Front/Components/DesignSystem/Typography";

export default function LinkInline({ text, href }: { text: string; href: string }): React.JSX.Element {
	return (
		<a href={href} target="_blank" rel="noreferrer">
			<Typography type="span" typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.TEXT_ACCENT}>
				{" "}
				{text}{" "}
			</Typography>
		</a>
	);
}
